import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { P, match } from "ts-pattern";
import { Box } from "./Box";
import { SlotsProvider } from "../providers/SlotsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system/styles";
import { breakpoints } from "../theme";
export const centeredLayoutClasses = {
    root: "MinervaCenteredLayout-root",
    main: "MinervaCenteredLayout-main",
};
export const centeredLayoutSlots = {
    main: Box,
};
export const CenteredLayout = (props) => {
    const { maxWidth = 125, sx, slots, slotProps, className, children, ...rest } = useDefaultProps({
        component: "CenteredLayout",
        props,
    });
    return (_jsx(SlotsProvider, { baseSlots: centeredLayoutSlots, slots: slots, children: ({ main: Main }) => (_jsx(Box, { height: "100%", width: "100%", sx: mergeSx({ display: "flex" }, sx), className: clsx([className, centeredLayoutClasses.root]), ...rest, children: _jsx(Main, { width: "100%", ...slotProps?.main, className: clsx([centeredLayoutClasses.main, slotProps?.main?.className]), sx: mergeSx({
                    margin: "auto",
                    maxWidth: (theme) => match(maxWidth)
                        .with(P.union(...breakpoints), (value) => `${theme.breakpoints[value]}px`)
                        .otherwise(() => maxWidth),
                }, slotProps?.main?.sx), children: children }) })) }));
};
export default CenteredLayout;
//# sourceMappingURL=CenteredLayout.js.map